import { render } from "./FieldInstancesForm.vue?vue&type=template&id=021a2673"
import script from "./FieldInstancesForm.vue?vue&type=script&lang=js"
export * from "./FieldInstancesForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__